// src/modules/walkInCase/api.js
import API from '../../services/api';

export const fetchWalkInCases = ({ search = '', page = 1, limit = 10, status = '', inventoryStatus = '', branch = '', createdAfter = '', createdBefore = '', ...extra } = {}) =>
  API.get('/walk-in-cases', {
    params: {
      search,
      page,
      limit,
      ...(status ? { status } : {}),
      ...(inventoryStatus ? { inventoryStatus } : {}),
      ...(branch ? { branch } : {}),
      ...(createdAfter ? { createdAfter } : {}),
      ...(createdBefore ? { createdBefore } : {}),
      // searchField, metalType, paymentMode, agentId, minAmount, maxAmount — blanks dropped
      ...Object.fromEntries(Object.entries(extra).filter(([, v]) => v !== '' && v !== null && v !== undefined)),
    },
  }).then((r) => r.data);

export const getWalkInCaseById = (id) =>
  API.get(`/walk-in-cases/${id}`).then((r) => r.data);

export const createWalkInCase = (data) =>
  API.post('/walk-in-cases', data).then((r) => r.data);

export const updateWalkInCase = (id, data) =>
  API.patch(`/walk-in-cases/${id}`, data).then((r) => r.data);

// Soft delete by default; { permanent: true } is an admin-only hard delete.
export const deleteWalkInCase = (id, { permanent = false } = {}) =>
  API.delete(`/walk-in-cases/${id}`, { params: permanent ? { permanent: true } : {} }).then((r) => r.data);

export const restoreWalkInCase = (id) =>
  API.post(`/walk-in-cases/${id}/restore`).then((r) => r.data);

export const generateBill = (id) =>
  API.post(`/walk-in-cases/${id}/generate-bill`).then((r) => r.data);

export const confirmGoldReceived = (id) =>
  API.post(`/walk-in-cases/${id}/confirm-gold-received`).then((r) => r.data);

export const generateAgreement = (id) =>
  API.post(`/walk-in-cases/${id}/generate-agreement`).then((r) => r.data);

export const startWalkInESign = (id) =>
  API.post(`/walk-in-cases/${id}/esign/start`).then((r) => r.data);

export const finalizeWalkInESign = (id) =>
  API.post(`/walk-in-cases/${id}/esign/finalize`).then((r) => r.data);
